


























































import { Component, Mixins, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component
export default class HomepageTakeover extends Vue {
  @State(cmsContent => cmsContent.homepageTakeover, {
    namespace: 'cmsContent',
  })
  hpto!: any;

  get customFontFamily() {
    const url = new URL(this.hpto.customFont);
    const params = new URLSearchParams(url.search);
    return params.has('family') ? params.get('family') : 'sans-serif';
  }

  goTo(route: string) {
    this.$ua.trackHomepageTakeoverEvent({
      takeover: this.hpto.name,
    });
    this.$router.push(route);
  }
}
